import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';

import { CandidateAdapter, User } from '@shared/models';

export enum UserTemplateTypes {
  extended = 'extended',
  nameOnly = 'nameOnly',
  listItem = 'listItem',
  material = 'material',
}

@Component({
  selector: 'mojo-users-item',
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserItemComponent {
  @Input() user: User;
  @Input() templateType: UserTemplateTypes;

  userTemplateTypes = UserTemplateTypes;
  avatarPhotoShape = AvatarShapes.circle;
  avatarBackgroundSize = AvatarBackgroundSizes.cover;

  get candidate() {
    return new CandidateAdapter({
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      candidateImageId: this.user.photoId,
    });
  }
}
